export default "__VITE_ASSET__DLM0BF____"